import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { type Observable, tap } from "rxjs";
import { type Comment, type CreateCommentInput } from "src/app/schema";
import { environment } from "src/environments/environment";

@Injectable({
	providedIn: "root",
})
export class CommentService {
	private readonly _httpClient = inject(HttpClient);

	public postLeadComment(
		leadId: string,
		propertyId: string,
		comment: string,
	): Observable<Comment> {
		return this._httpClient.post<Comment>(
			`${environment.communicationsEndpoint}/leads/${leadId}/comments/post`,
			{ comment, propertyId },
		);
	}

	public postApplicationComment(
		applicationId: string,
		comment: string,
	): Observable<Comment> {
		return this._httpClient
			.post<Comment>(
				`${environment.applicationsEndpoint}/applications/${applicationId}/comments/post`,
				{ comment },
			)
			.pipe(tap((response) => console.log(response)));
	}

	public createCampaignComment(
		comment: CreateCommentInput,
	): Observable<Comment> {
		return this._httpClient.post<Comment>(
			`${environment.marketingEndpoint}/comment`,
			comment,
		);
	}
}
